import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "team-select-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "team_select",
  class: "survey_prompt case-inherit"
}, [
  /*#__PURE__*/_createElementVNode("i", null, "Select a team:")
], -1)

import { ref, onMounted, computed } from "vue";
import { getTeams, APITeam } from "@/services/teamService";
import TandemSelect2 from "@/components/TandemSelect2.vue";
import TeamEvaluationTabContent from "@/components/TeamEvaluationTeamTabContent.vue";

interface Props {
  cohortId: number;
  cohortSurveyId: number;
}

interface Select2Option {
  id: number;
  text: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamEvaluationTeamTab',
  props: {
    cohortId: {},
    cohortSurveyId: {}
  },
  setup(__props: any) {

const props = __props;



const teams = ref<APITeam[]>([]);
const teamId = ref<number>();

const options = computed<Select2Option[]>(() =>
  teams.value.map((team) => ({
    id: team.id,
    text: team.name,
  }))
);
const selectedTeam = computed<APITeam | undefined>(() =>
  teams.value.find((team) => team.id === teamId.value)
);

onMounted(async () => {
  teams.value = await getTeams(props.cohortId);
  teamId.value = teams.value[0]?.id;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(TandemSelect2, {
        options: options.value,
        modelValue: teamId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((teamId).value = $event)),
        placeholder: "Select a team",
        id: "team_select"
      }, null, 8, ["options", "modelValue"])
    ]),
    (selectedTeam.value)
      ? (_openBlock(), _createBlock(TeamEvaluationTabContent, {
          key: selectedTeam.value.id,
          "cohort-id": _ctx.cohortId,
          "cohort-survey-id": _ctx.cohortSurveyId,
          team: selectedTeam.value
        }, null, 8, ["cohort-id", "cohort-survey-id", "team"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})